module.exports = __webpack_public_path__ + "img/maslahat-2.164ba03e.png";